<span class="CitySelect" uk-toggle="target: #ModalCitySelect">
	<span class="CitySelect_Text">{{ cityService.city.NAME }}</span>
	<span class="IconItem IconItem--arrowRight">
		<img src="/assets/img/icon/arrow-right.svg" uk-svg>
	</span>
</span>

<div class="CitySelectModal uk-flex-top uk-modal" id="ModalCitySelect" #modal>
    <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical">
        <div class="uk-modal-close-default">
			<span class="IconItem IconItem--close">
				<img src="/assets/img/icon/close.svg" uk-svg>
			</span>
		</div>
        <div *ngIf="cities.length > 0" class="uk-child-width-1-2 uk-child-width-1-4@m uk-grid" uk-grid>
			<span class="uk-display-block uk-link" *ngFor="let city of cities">
			    <a (click)="changeCurrentCity(city.CODE)" [routerLink]="['/regions', city.CODE]">{{ city.NAME }}</a>
            </span>
		</div>
        <!-- <div class="uk-margin-large-top">
			<a class="uk-text-muted" href="#">Как начать сотрудничество?</a>
		</div> -->
    </div>
</div>
